<template>
  <div id="sliderContainer">
    <div class="arrowContainer">
      <img src="../assets/arrow-small.png" alt="Arrow Left" style="transform: rotate(180deg)" @click="prevTheSlide" />
      <img src="../assets/arrow-small.png" alt="Arrow Right" @click="nextTheSlide" />
    </div>

    <div class="dotsContainer">
      <div class="dots" @click="jumpToSlide(0)" />
      <div class="dots" @click="jumpToSlide(1)" />
      <div class="dots" @click="jumpToSlide(2)" />
    </div>

    <div class="sliderContainer">
      <img class="sliderItem hiddenSlider" src="../assets/banner-1.jpg" alt="Banner 1" key="banner-1" />
      <img class="sliderItem hiddenSlider" src="../assets/banner-2.jpg" alt="Banner 2" key="banner-2" />
      <img class="sliderItem hiddenSlider" src="../assets/banner-3.jpg" alt="Banner 3" key="banner-3" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    runSlider() {
      this.allSlider[0].setAttribute('class', 'sliderItem showSlider');
      this.allDots[0].setAttribute('class', 'dots activeDot');

      this.intervalSlider = setInterval(() => {
        if (this.counter === 6) {
          this.nextTheSlide();
        } else {
          this.counter++;
        }
      }, 1000);
    },

    nextTheSlide() {
      this.allSlider[this.current].setAttribute('class', 'sliderItem hiddenSlider');
      this.allDots[this.current].setAttribute('class', 'dots');

      if (this.current === this.allSlider.length - 1) {
        this.allSlider[0].setAttribute('class', 'sliderItem showSlider');
        this.allDots[0].setAttribute('class', 'dots activeDot');
        this.current = 0;
      } else {
        this.allSlider[this.current + 1].setAttribute('class', 'sliderItem showSlider');
        this.allDots[this.current + 1].setAttribute('class', 'dots activeDot');
        this.current++;
      }

      this.counter = 0;
    },

    prevTheSlide() {
      this.allSlider[this.current].setAttribute('class', 'sliderItem hiddenSlider');
      this.allDots[this.current].setAttribute('class', 'dots');

      if (this.current === 0) {
        this.allSlider[this.allSlider.length - 1].setAttribute('class', 'sliderItem showSlider');
        this.allDots[this.allSlider.length - 1].setAttribute('class', 'dots activeDot');
        this.current = this.allSlider.length - 1;
      } else {
        this.allSlider[this.current - 1].setAttribute('class', 'sliderItem showSlider');
        this.allDots[this.current - 1].setAttribute('class', 'dots activeDot');
        this.current--;
      }

      this.counter = 0;
    },

    jumpToSlide(index) {
      if (index !== this.current) {
        this.allSlider[this.current].setAttribute('class', 'sliderItem hiddenSlider');
        this.allDots[this.current].setAttribute('class', 'dots');
        this.allSlider[index].setAttribute('class', 'sliderItem showSlider');
        this.allDots[index].setAttribute('class', 'dots activeDot');
        this.current = index;
        this.counter = 0;
      }
    },
  },

  mounted() {
    this.runSlider();
  },

  data() {
    return {
      current: 0,
      allSlider: document.getElementsByClassName('sliderItem'),
      counter: null,
      allDots: document.getElementsByClassName('dots'),
    };
  },

  destroyed() {
    clearInterval(this.intervalSlider);
  },
};
</script>

<style>
#sliderContainer {
  display: none;
  text-align: center;
}

@media screen and (min-width: 768px) {
  #sliderContainer {
    display: block;
    height: 500px;
    overflow: hidden;
  }

  .sliderContainer {
    position: absolute;
    height: 475px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    left: 0;
    overflow: hidden;
  }

  .sliderItem {
    height: 475px;
    position: absolute;
    margin: auto;
  }

  .showSlider {
    visibility: visible;
    opacity: 1;
    transition: opacity 1s linear;
  }

  .hiddenSlider {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 1s, opacity 1s linear;
  }

  .arrowContainer {
    position: absolute;
    z-index: 3;
    height: 475px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 70%;
    margin-left: 15%;
  }

  .arrowContainer img {
    cursor: pointer;
  }

  .dotsContainer {
    position: absolute;
    z-index: 3;
    width: 5%;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-end;
    height: 400px;
    margin-left: 47.5%;
  }

  .dots {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    border: solid 1px var(--lightColor);
    cursor: pointer;
  }

  .activeDot {
    background-color: var(--lightColor);
    cursor: auto;
  }
}
</style>
